<messages>["../UserCreateUpdate"]</messages>

<template>
  <base-dialog
    v-model="dialog"
    scrollable
    mw0>
    <template #activator="{ on: outer }">
      <v-tooltip top>
        <template #activator="{ on: inner }">
          <v-icon v-on="{ ...outer, ...inner }">
            info
          </v-icon>
        </template>
        {{ $t ('click') }}
      </v-tooltip>
    </template>

    <user-group-info-card :groups="selectedGroupsDetailes" @close="dialog = false"/>
  </base-dialog>
</template>

<script>
  import UserGroupInfoCard from './UserGroupInfoCard'
  import BaseDialog from '@/app/core/components/BaseDialog'

  export default {
    components: {
      UserGroupInfoCard,
      BaseDialog
    },

    props: {
      availableGroups: {
        type: Array,
        required: true
      },

      selectedGroups: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        dialog: false
      }
    },

    computed: {
      selectedGroupsDetailes () {
        return this.selectedGroups.map ((g) => {
          return this.availableGroups.find ((g2) => g === g2.id)
        })
      }
    }
  }
</script>
